<template>
  <div class="container page" style="background-color: #fff;">
    <div class="header">
      <van-nav-bar :title="$t('msg.messages')" class="nav-bar">
        <template #left>
          <div class="flex" @click="back">
            <van-icon name="arrow-left" size="22" color="#333" />
            <div style="font-size:14px;color: #333;">{{ $t('msg.back') }}</div>
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div class="tabbar">
        <div class="tabbar-item" @click="changetabbar(1)" :class="{active:tabbar==1}">{{ $t('msg.inbox') }}</div>
        <!-- <div class="tabbar-item" @click="changetabbar(2)" :class="{active:tabbar==2}">网站公告</div> -->
    </div>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div style="text-align: center;line-height: 50px;height: 300px;" v-show="notice.length==0">{{ $t('msg.no_data') }}</div>
          <div class="listItem" v-for="(v,key) in notice" @click="$refs.noticeDetailPop.show(v)" :key="key">
            <div class="listTitle">{{ v.name }}</div>
            <!-- <div class="listContent html"><p>{{ v.text }}<br></p></div> -->
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
            <div class="listMore">
              <div>
                {{ $t('msg.tap_to_view') }}
              </div>
              <van-icon name="arrow" size="16" color="#999" />
            </div>
          </div>
      </van-pull-refresh>
      <div style="height: 60px;"></div>
    </div>
    <noticeDetailPop ref="noticeDetailPop"></noticeDetailPop>
  </div>

</template>

<script>
import noticeDetailPop from '@/pages/notice/noticeDetailPop.vue'
export default {
  components:{noticeDetailPop},
  data() {
    return {
        tabbar:1,
      isLoading: false,
      notice:[],
      loading: false,
      finished: false,
    };
  },
  methods: {
    changetabbar(val){
      this.tabbar=val
      this.notice=[]
      this.getNoticeList()
    },
    back(){
      return window.history.back();
    },
    getNoticeList(){
      this.$http({
        method: 'get',
        // url: this.tabbar==1?'member_message_list':'sys_get_notice_list'
        url: 'member_message_list'
      }).then(res=>{
        console.log(res);
        if(res.code==200){
          this.notice = res.data
        }
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

/deep/ .van-tabs__nav {
  background: #fff;
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: #fff;
  border-bottom-width: 0;
}
.tabbar{
    height: 88px;
    display: flex;
    align-items: center;
    .tabbar-item{
        font-size: 28px;
        flex: 1;
        width: 50%;
        line-height: 88px;
        text-align: center;
        background-color: #f8f8f8;
        color: #666;
        &.active{
            background-color: #fff;
            color: #F297A2;
        }
    }
}
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .content {
  height: calc(100% - 20px);
  flex: 1;
  overflow: auto;
  background: #f4f4f4;
}
.container .content .listItem{
  padding: 20px 20px 0;
  position: relative;
  color: #333;
  background-color: #fff;
  margin: 20px 24px 0 24px;
  border-radius: 4px;
}
.container .content .listItem .listTitle{
  font-size: 32px;
  color: #000;
}
.container .content .listItem .listContent{
  border-bottom: 2px solid #f2f2f5;
  padding: 5px 0;
  font-size: 25px;
}
.container .content .listItem .listTime{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 60px;
}
.container .content .listItem .listTime .listTimeText {
  color: #999;
  font-size: 24px;
}
.listMore{
  border-top: 1px solid #eee;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 28px;
  color: #999;
}
</style>
